// src/TopNavigation.jsx

import React, { useContext, useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from './AuthContext';
import { FaBell, FaUserCircle } from 'react-icons/fa';
import Login from './Login';
import Signup from './Signup';

const TopNavigation = () => {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [showSignup, setShowSignup] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShowUserDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const go = (to) => {
    setShowUserDropdown(false);
    navigate(to);
  };

  const menuItems = [
    { label: 'Your designs', onClick: () => go(`/userpage/${user?.username}`) },
    { label: 'Premium', icon: '💎', onClick: () => go('/subscribe') },
    { label: 'Settings & privacy', onClick: () => go('/settings') },
    { label: 'Help', onClick: () => go('/support') },
    { label: 'Sign out', onClick: () => { setShowUserDropdown(false); logout(); }, danger: true },
  ];

  return (
    <>
      <header className="flex h-16 items-center justify-end border-b border-white/10 bg-gray-900 px-4">
        {/* User area */}
        <div className="relative flex items-center gap-2" ref={dropdownRef}>
          {user ? (
            <>
              <button
                className="flex h-9 w-9 items-center justify-center rounded-full text-white/55 transition-colors hover:bg-white/5 hover:text-white"
                aria-label="Notifications"
              >
                <FaBell className="text-lg" />
              </button>

              <button
                onClick={() => setShowUserDropdown((p) => !p)}
                className="flex items-center rounded-full ring-2 ring-transparent transition hover:ring-white/15"
                aria-label="Account menu"
              >
                {user.user_avatar ? (
                  <img
                    src={user.user_avatar}
                    alt="Avatar"
                    className="h-9 w-9 rounded-full object-cover"
                  />
                ) : (
                  <FaUserCircle className="text-3xl text-white/70" />
                )}
              </button>

              {showUserDropdown && (
                <div className="absolute right-0 top-12 z-50 w-56 overflow-hidden rounded-2xl border border-white/10 bg-gray-900 shadow-2xl shadow-black/50">
                  <div className="border-b border-white/10 px-4 py-3">
                    <p className="truncate text-sm font-semibold text-white">{user.username}</p>
                    <p className="truncate text-xs text-white/40">{user.email}</p>
                  </div>
                  <div className="py-1.5">
                    {menuItems.map((item) => (
                      <button
                        key={item.label}
                        onClick={item.onClick}
                        className={`flex w-full items-center gap-2 px-4 py-2.5 text-left text-sm transition-colors hover:bg-white/5 ${
                          item.danger ? 'text-rose-400 hover:text-rose-300' : 'text-white/70 hover:text-white'
                        }`}
                      >
                        {item.icon && <span>{item.icon}</span>}
                        {item.label}
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </>
          ) : (
            <>
              <button
                onClick={() => setShowLogin(true)}
                className="rounded-full border border-white/15 px-4 py-2 text-sm font-medium text-white/80 transition hover:border-white/30 hover:text-white"
              >
                Log in
              </button>
              <button
                onClick={() => setShowSignup(true)}
                className="rounded-full bg-gradient-to-r from-rose-500 to-pink-600 px-4 py-2 text-sm font-semibold text-white shadow-lg shadow-rose-500/20 transition hover:brightness-110"
              >
                Sign up
              </button>
            </>
          )}
        </div>
      </header>

      {/* Login Modal */}
      {showLogin && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4 backdrop-blur-sm">
          <div className="relative w-full max-w-md rounded-2xl bg-white p-4 shadow-2xl">
            <button
              className="absolute right-3 top-3 text-gray-500 hover:text-gray-800"
              onClick={() => setShowLogin(false)}
            >
              ✕
            </button>
            <Login onClose={() => setShowLogin(false)} />
          </div>
        </div>
      )}

      {/* Signup Modal */}
      {showSignup && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4 backdrop-blur-sm">
          <div className="relative w-full max-w-md rounded-2xl bg-white p-4 shadow-2xl">
            <button
              className="absolute right-3 top-3 text-gray-500 hover:text-gray-800"
              onClick={() => setShowSignup(false)}
            >
              ✕
            </button>
            <Signup onClose={() => setShowSignup(false)} />
          </div>
        </div>
      )}
    </>
  );
};

export default TopNavigation;
